module.exports = __webpack_public_path__ + "img/new101_en.edc4bd72.jpg";